export {
  menuLinks,
  socialLinks,
  // profileLinks
} from './links';

export const APP_NAME = 'Rebuilt Marketplace';
export const APP_TITLE = (title: string) => `${title} | ${APP_NAME}`;
